<template>
    <a-modal
        id="integrate-story-list-with-telegram-bot-modal"
        :title="$t('chatbotv2.integrateStoryWithTelegram')"
        wrapClassName="vertical-center-modal"
        :visible="modalVisible"
        @visibleChange="(isVisible) => $emit('modal-visible2', isVisible)"
        :footer="null"
        @cancel="handleCancel()"
    >
        <a-form class="d-flex flex-column justify-content-center" @submit.prevent="handleSave">
            <div class="col mb-5">
                <a-form-item :label="$t('telegram.typeInTelegramToken')">
                    <a-modal
                        v-model="visibleDeleteToken"
                        :title="$t('chatbotv2.deleteTokenConfirm')"
                        @ok="confirmDeleteToken"
                        @cancel="cancelDeleteToken"
                    >
                        <p v-if="!!this.selectedStory">{{ $t("chatbotv2.integratedStoryRevoked") }}</p>
                        <p>{{ $t("chatbotv2.tokenLostPermanently") }}</p>
                    </a-modal>
                    <div class="row mb-3">
                        <a-input
                            autofocus
                            class="mt-2"
                            :class="{ 'err-class': showWarning }"
                            @change="onChange"
                            v-model="tempToken"
                            :placeholder="$t('telegram.token')"
                        />
                    </div>
                </a-form-item>
                <a-form-item :label="$t('chatbotv2.selectIntegratingStory')">
                    <div class="row mb-3">
                        <a-select v-model="selectedStory" @change="handleChange">
                            <a-select-option :key="story.id" v-for="story in stories" :value="story.id"
                                >{{ story.title }}
                            </a-select-option>
                        </a-select>
                    </div>
                </a-form-item>
            </div>
        </a-form>
        <div class="d-flex flex-row justify-content-between">
            <div class="d-flex flex-row justify-content-start">
                <a-button type="danger" v-if="!!selectedStory" @click="revokeDefault()">
                    <span> <a-icon type="api" class="px-1" /></span>{{ $t("chatbotv2.uninstall") }}
                </a-button>
            </div>
            <div class="d-flex flex-row justify-content-end">
                <a-button class="mr-1 ant-btn-primary" @click="handleOk()" :disabled="!isChangedStory || showWarning">
                    {{ $t("chatbotv2.install") }}
                </a-button>
                <a-button class="ml-1" @click="handleCancel()">{{ $t("message.cancel") }}</a-button>
            </div>
        </div>
    </a-modal>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import { sendSocketMessage } from "../../../../../../utils/socketStream";

export default {
    name: "SelectStoryIntegratingWithTelegramBot",
    props: {
        modalVisible: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            stories: (state) => state.CB.stories,
            settings: (state) => state.setting.settings,
        }),
        token: {
            get() {
                return _.get(this.settings, "telegrambot.token", null);
            },
            set(value) {
                this.setValue("telegrambot.token", value);
            },
        },
    },
    data() {
        return {
            selectedStory: undefined,
            isChangedStory: false,
            showWarning: false,
            tempToken: "",
            visibleDeleteToken: false,
            handleSaveSetting: _.debounce((newSettings) => {
                this.updateSettings(newSettings);
            }, 1000).bind(this),
        };
    },
    methods: {
        ...mapActions({
            listStories: "CB/listStories",
            makeDefaultStory: "CB/makeDefaultStory",
            revokeDefaultStory: "CB/revokeDefaultStory",
            getSettings: "setting/getSettings",
            updateSettings: "setting/updateSettings",
            setSettingValue: "setting/setSettingValue",
        }),
        handleSave() {
            if (!this.selectedStory) return;
            this.makeDefaultStory({ selectedStory: this.selectedStory, integrationApp: "telegram" });
            this.$emit("modal-visible", false);
            this.isChangedStory = false;
            sendSocketMessage("user settings-updated", {
                siteId: this.site._id,
            });
        },
        reset() {
            this.selectedStory = null;
            this.isChangedStory = false;
        },
        handleOk() {
            if (!!this.tempToken && !!this.tempToken.length) {
                this.showWarning = false;
                this.handleSave();
                this.token = this.tempToken;
            } else {
                this.showWarning = true;
            }
        },
        onChange(e) {
            this.tempToken = e.target.value;
            this.showWarning = false;
        },
        handleChange() {
            this.isChangedStory = true;
        },
        handleCancel() {
            this.$emit("modal-visible", false);
            if (this.isChangedStory === true) {
                this.selectedStory = _.get(
                    this.stories.find((x) => _.get(x, "integrations.telegram")),
                    "id"
                );
                this.isChangedStory = false;
            }
        },
        revokeDefault() {
            this.revokeDefaultStory({ integrationApp: "telegram" });
            this.$emit("modal-visible", false);
            this.reset();
        },
        confirmDeleteToken() {
            this.token = null;
            this.visibleDeleteToken = false;
            if (!!this.selectedStory) this.revokeDefault();
            else this.$emit("modal-visible", false);
        },
        cancelDeleteToken() {
            this.tempToken = this.token;
            this.visibleDeleteToken = false;
        },
        setValue(key, value) {
            const newSettings = this.setSettingValue({
                setting: key,
                value,
            });

            if (newSettings.then) {
                newSettings.then((x) => this.handleSaveSetting(x));
            } else {
                this.handleSaveSetting(newSettings);
            }
        },
    },
    mounted() {
        if (!!this.token) this.tempToken = this.token;
    },
    watch: {
        stories: {
            handler(newVal) {
                if (newVal)
                    this.selectedStory = _.get(
                        this.stories.find((x) => _.get(x, "integrations.telegram")),
                        "id"
                    );
            },
            deep: true,
        },
        token(newVal, oldVal) {
            if (!!newVal && !!newVal.length > 0) {
                if (!oldVal) {
                    this.tempToken = newVal;
                }
            }
        },
        tempToken(newVal) {
            if (newVal === "") {
                this.visibleDeleteToken = true;
            }
        },
    },
};
</script>

<style lang="scss">
.vertical-center-modal {
    text-align: center;
    white-space: nowrap;
}

.vertical-center-modal:before {
    content: "";
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    width: 0;
}

.vertical-center-modal .ant-modal {
    display: inline-block;
    vertical-align: middle;
    top: 0;
    text-align: left;
}

.err-class {
    border: 1px solid red !important;
}
</style>
